export const async_amazon_search = {
  asyncType: 'amazon-search',
  hostedScraperType:  'async_amazon_search',
  publicHostedScraperAPIType:  'amazon_search',
  inputKey: 'query',
  inputsKey: 'queries',
  inputJsonSchema: { type: 'string' },
  asyncEndpoint: '/structured/amazon/search',
  apiEndpoint: '/structured/amazon/search',
  apiCostEndpoint: '/account/amazonsearchcost',
  propertiesJsonSchemaPart: {
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' },
    country_code: { type: 'string' },
    ref: { type: 'string' },
    s: { type: 'string' },
    i: { type: 'string' },
    page: { type: 'string', pattern: '[0-9]+' }
  }
};
